import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../shared/services/logging/logging.service';
import { CategoriesService } from '../shared/category/categories.service';
import { processResolver } from './process-resolver';
import { ContractCumulativeFeatureComponent } from '../contract-cumulative/feature/contract-cumulative-feature.component';

const log = new LoggingService();
export const ContractCumulativeRoute: Ng2StateDeclaration = {
    name: 'contractcum',
    url: '/contractcum',
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: ContractCumulativeFeatureComponent
};
